/**
 * CAJA PAGE - Control de Caja
 */
import { Wallet } from "lucide-react";
import { PlaceholderPage } from "../placeholder-page";

export default function CajaPage() {
  return <PlaceholderPage titleKey="caja.title" descriptionKey="caja.description" icon={Wallet} />;
}
